import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BTActivationPrintRequest } from "./BTActivationPrintRequest";
import { QREmailRequest } from "./QREmailRequest";
import { PreviewQRRequest } from "./PreviewQRRequest";
import { BTActivationInsertRequest } from "./BTActivationInsertRequest";
import { BTActivationUpdateRequest } from "./BTActivationUpdateRequest";

@Injectable()
export class DataService_BusTrackerActivation {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BTActivationSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/BTActivationSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BTActivationInsert(parms: BTActivationInsertRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BTActivationInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BTActivationUpdate(parms: BTActivationUpdateRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BTActivationUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BTActivationPreviewDebugQRCode(parms: PreviewQRRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BTActivationPreviewDebugQRCode";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BTActivationPrint(parms: BTActivationPrintRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BTActivationPrint";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BTActivationEmail(parms: QREmailRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BTActivationEmail";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
